var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsNanoTechnology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 26.6666L16.6668 21.6666M23.3335 18.3333L31.6668 13.3333M20.0002 8.33331V16.6666M20.0002 23.3333V31.6666M8.3335 13.3333L16.6668 18.3333M23.3335 21.6666L31.6668 26.6666M34.1668 15V24.1666M22.5002 34.1666L31.6668 29.1666M7.50016 29.1666L17.5002 34.1666M5.8335 25V15M7.50016 10.8333L17.5002 5.83331M32.5002 10.8333L22.5002 5.83331",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.83331C22.5 7.21402 21.3807 8.33331 20 8.33331C18.6193 8.33331 17.5 7.21402 17.5 5.83331C17.5 4.4526 18.6193 3.33331 20 3.33331C21.3807 3.33331 22.5 4.4526 22.5 5.83331Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 34.1666C22.5 35.5473 21.3807 36.6666 20 36.6666C18.6193 36.6666 17.5 35.5473 17.5 34.1666C17.5 32.7859 18.6193 31.6666 20 31.6666C21.3807 31.6666 22.5 32.7859 22.5 34.1666Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 12.5C8.3335 13.8807 7.21421 15 5.8335 15C4.45278 15 3.3335 13.8807 3.3335 12.5C3.3335 11.1193 4.45278 10 5.8335 10C7.21421 10 8.3335 11.1193 8.3335 12.5Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 12.5C36.667 13.8807 35.5477 15 34.167 15C32.7863 15 31.667 13.8807 31.667 12.5C31.667 11.1193 32.7863 10 34.167 10C35.5477 10 36.667 11.1193 36.667 12.5Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 27.5C36.667 28.8807 35.5477 30 34.167 30C32.7863 30 31.667 28.8807 31.667 27.5C31.667 26.1193 32.7863 25 34.167 25C35.5477 25 36.667 26.1193 36.667 27.5Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 27.5C8.3335 28.8807 7.21421 30 5.8335 30C4.45278 30 3.3335 28.8807 3.3335 27.5C3.3335 26.1193 4.45278 25 5.8335 25C7.21421 25 8.3335 26.1193 8.3335 27.5Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 16.25L23.3337 18.125V21.875L20.0003 23.75L16.667 21.875V18.125L20.0003 16.25Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#0D99FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsNanoTechnology);
export default __webpack_public_path__ + "static/media/hugeicons_nano-technology.25c7e19ebfd0d22ce430823379dc38be.svg";
export { ForwardRef as ReactComponent };